module.exports = __webpack_public_path__ + "static/zuggtmoy-e9e348c3d481aad90296ee7525526e4c.jpg";